import RichText from '../components/RichText';

export default class Page {
  constructor() {
    this.rteEl = document.querySelector('[data-rte]');
    this.rte = this.rteEl ? new RichText(this.rteEl) : false;
  }
}
